export default "__VITE_ASSET__DK8uqJ5c__"